var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg16894229181556105318(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.745 10.745 0 24 0s24 10.745 24 24-10.745 24-24 24S0 37.255 0 24z",
    fill: "#2E2882"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2 16.017l-6.02 4.763-8.78-5.356 6.093-5.024 8.707 5.617zM18.307 10.4l6.093 5.024-8.78 5.356-6.02-4.763 8.707-5.617zm-2.686 10.38l8.779 5.356 8.78-5.356 6.02 4.764-8.707 5.616-6.093-5.024-6.093 5.024L9.6 25.544l6.02-4.764zm14.908 11.446l-6.111-5.01-6.11 5.01-2.616-1.686v1.89l8.726 5.17 8.725-5.17v-1.89l-2.614 1.686z",
    fill: "#FEB0A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg16894229181556105318);
export default __webpack_public_path__ + "static/media/16894229181556105318.2b4bd1c28bd4a744c67804b0a15fd108.svg";
export { ForwardRef as ReactComponent };